"use strict";

(() => {
  const header = document.querySelector(".p-header");

  if (!header) {
    return;
  }

  const THRESHOLD = 100;
  let ticking = false;

  const update = () => {
    ticking = false;
    header.classList.toggle("is-scrolled", window.scrollY > THRESHOLD);
  };

  const onScroll = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    requestAnimationFrame(update);
  };

  update();
  window.addEventListener("scroll", onScroll, { passive: true });
})();
